<template>
  <!-- 属性数据 -->
  <div class="attr">
    <div class="bar">
      <div class="title">面板数据</div>
      <div class="more" @click="handleOpenMore">查看更多<i class="el-icon-arrow-right"></i></div>
      <!-- 显示更多数据 -->
      <el-dialog
        title=""
        custom-class="more-drawer"
        :visible.sync="drawer"
        :after-close="handleCloseMore"
        width="436px"
        append-to-body
      >
        <div class="more-content">
          <div class="header">
            <div class="title">角色面板</div>
            <div class="close">
              <img src="@/assets/zs_imgs/close-icon.png" alt="" @click="handleCloseMore" />
            </div>
          </div>
          <div class="content">
            <table class="table" border="0">
              <colgroup>
                <col width="33%" />
                <col width="21%" />
                <col width="21%" />
                <col width="25%" />
              </colgroup>
              <thead>
                <tr>
                  <th></th>
                  <th style="text-align: center;">1级</th>
                  <th style="text-align: center;">满级</th>
                  <th style="text-align: center;">满刻印觉醒</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="key in Object.keys(dataSource)" :key="key">
                  <td>
                    <img class="icon" alt="" :src="dataSource[key].icon.value" />
                    <span>{{ dataSource[key].name.value }}</span>
                  </td>
                  <td style="color: #999999;text-align: center;">
                    <span>{{ dataSource[key].level1.value }}</span>
                  </td>
                  <td style="color: #999999;text-align: center;">
                    <span>{{ dataSource[key].level100.value }}</span>
                  </td>
                  <td style="color: #FFBC52;text-align: center;">
                    <span>{{ dataSource[key].levelFull.value }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="attr-list">
      <template v-for="(key, index) in Object.keys(dataSource).slice(0, 7)">
        <div
          class="attr-item"
          :key="key"
          v-if="!(['攻击力', '魔法力'].includes(dataSource[key].name.value) && dataSource[key].level100.value == 0)"
        >
          <div class="attr-name">
            {{ dataSource[key].name.value }}
          </div>
          <div class="attr-value">
            {{ dataSource[key].level100.value }}
          </div>
        </div>
        <div
          class="divider"
          v-if="
            !(['攻击力', '魔法力'].includes(dataSource[key].name.value) && dataSource[key].level100.value == 0) &&
              index !== 6
          "
        ></div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  inject: {
    refreshMap: {
      default: () => {}
    }
  },
  data() {
    return {
      drawer: false
    };
  },
  mounted() {},
  methods: {
    handleOpenMore() {
      this.drawer = true;
      this.$nextTick(() => {
        if (this.refreshMap) this.refreshMap();
      });
    },
    handleCloseMore() {
      this.drawer = false;
    }
  }
};
</script>
<style lang="less" scoped>
.attr {
  width: 100%;
  margin-bottom: 48px;
  .bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 33px;
    .title {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      color: #ffffff;
    }
    .more {
      height: 20px;
      background: #e1dad5;
      border-radius: 11px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 12px;
      line-height: 12px;
      color: #392e25;
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 0 10px;
      gap: 10px;
      i {
        padding-top: 2px;
      }
    }
  }

  .attr-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .divider {
      width: 1px;
      height: 33px;
      background: rgba(255, 255, 255, 0.06);
    }
    .attr-item {
      .attr-name {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 18px;
        color: #ffffff;
        line-height: 18px;
        margin-bottom: 13px;
      }
      .attr-value {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 15px;
        color: #ffbc52;
        line-height: 15px;
      }
    }
  }
}
/deep/ .more-drawer {
  background: transparent;
  box-shadow: none;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    background: transparent;
  }
  .more-content {
    position: relative;
    height: 100%;
    background: url("~@/assets/zs_imgs/dialog-bg.png") no-repeat;
    background-size: 100% 100%;
    padding: 60px 17px 16px 21px;
    .header {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      padding: 24px 10px;
      .title {
        position: relative;
        left: -5px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #fffefe;
        background: url("~@/assets/zs_imgs/dialog-title-bg.png") no-repeat;
        background-size: 152px 38px;
        background-position: -30px 0;
        width: 122px;
        height: 38px;
        line-height: 38px;
        padding-left: 22px;
      }

      .close {
        position: absolute;
        right: 22px;
        top: 30px;
        width: 18px;
        height: 18px;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
    }
    .content {
      height: calc(100% - 60px);
      .table {
        width: 100%;
        border: none;
        table-layout: fixed;
        border-collapse: collapse;
        thead {
          tr {
            th {
              height: 44px;
              font-weight: 600;
              font-size: 12px;
              color: #ffffff;
              line-height: 44px;
              text-align: left;
              padding: 0 10px;
            }
          }
        }
        tbody {
          tr {
            &:last-child {
              td {
                border: none;
              }
            }
            td {
              height: 44px;
              font-family: PingFang SC;
              font-weight: 600;
              font-size: 16px;
              color: #ffffff;
              line-height: 42px;
              border-bottom: 1px solid rgba(255, 255, 255, 0.04);
              .icon {
                width: 20px;
                height: 20px;
                margin-right: 9px;
                vertical-align: middle;
              }
            }
          }
        }
      }
    }
  }
}
</style>
